import { withRouter } from 'react-router'
import DetailMedia from './../../components/DetailMediaPage/DetailMedia'
import { connect } from 'react-redux';
import { getMediaVietId } from '../../graphqlDic';
import { graphql, compose } from 'react-apollo';
import jwtDecode from 'jwt-decode';

const token = localStorage.getItem('token');

let loggedInUser = null;
if (token) {
    loggedInUser = jwtDecode(token);
}

export default compose(graphql(getMediaVietId, {
    name: 'getMediaVietId',
    options: (ownProps) => ({
        variables: {
            id: ownProps.match.params.id_media,
            viet_id: token ? loggedInUser.id : null
        }
    })
}))(withRouter(
    connect(
        null,
        null
    )(DetailMedia)
)
);



// WEBPACK FOOTER //
// ./src/containers/DetailMediaPage/DetailMedia.js